<template>
  <div class="col-12">
    <div class="row">
      <div class="col-lg-5">
        <small class="text-small text-black-50">SHORTCUTS:</small><br />
        <router-link
          class="btn btn-sm mr-2 btn-outline-primary"
          :to="{ name: 'pallets-movements-create' }"
          v-if="userHasPerms(['Pallet Movements'])"
        >
          <i class="lni lni-circle-plus m-0 font-size-19 my-2"></i> <br />
          Create Movement
        </router-link>

        <router-link
          class="btn btn-sm mr-2 btn-outline-primary"
          :to="{ name: 'pallets-movements' }"
          v-if="userHasPerms(['Pallet Movements'])"
        >
          <i class="lni lni-agenda m-0 font-size-19 my-2"></i> <br />
          Movements
        </router-link>

        <router-link
          class="btn btn-sm mr-2 btn-outline-primary"
          :to="{ name: 'pallets-adjustments' }"
          v-if="userHasPerms(['Pallet Adjustments'])"
        >
          <i class="lni lni-pencil m-0 font-size-19 my-2"></i> <br />
          Adjustments
        </router-link>
      </div>
      <div class="col-lg-7">
        <div class="card " v-if="openTransfers.length > 0" >
          <div class="card-body" style="max-height:500px;">
            <h5 class="card-title border-0">Open Transfers</h5>
            <table class="table">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td>Sent</td>
                  <td>Remark</td>
                  <td>From</td>
                  <td>To</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="movement in openTransfers" :key="movement.id">
                  <td>
                    {{
                      moment(new Date(movement.created_at)).format(
                        "DD MMM, HH:mm"
                      )
                    }}
                  </td>
                  <td>{{ movement.remark }}</td>
                  <td v-if="movement.from_branch">
                    {{ movement.from_branch.code }}
                  </td>
                  <td v-if="movement.to_branch">
                    {{ movement.to_branch.code }}
                  </td>
                  <td class="text-right">
                    <router-link
                      v-b-tooltip.hover
                      title="Receive"
                      :to="{
                        name: 'pallets-movements-received',
                        params: { id: movement.id },
                      }"
                      class="text-primary table-action-icon"
                    >
                      <i class="lni lni-arrow-down-circle"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-5">
      <div class="card-body">
        <h5 class="card-title border-0 m-0">Branches Overview</h5>
        <small class="text-black-50"> Click branch name for statement</small>
        <div class="row">
          <div class="col-lg-8">
            <table class="table mt-3">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td rowspan="2">Branch</td>
                  <td rowspan="2">Balance</td>
                  <td colspan="2" class="text-center">Today</td>
                  <td colspan="2" class="text-center">
                    {{ moment().format("MMMM") }}
                  </td>
                  <td colspan="2" class="text-center">90 Days</td>
                </tr>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td class="text-center text-warning">In</td>
                  <td class="text-center text-info">Out</td>
                  <td class="text-center text-warning">In</td>
                  <td class="text-center text-info">Out</td>
                  <td class="text-center text-warning">In</td>
                  <td class="text-center text-info">Out</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="branch in branches" :key="branch.id">
                  <td>
                    <router-link
                      v-b-tooltip.hover
                      title="Branch Statement"
                      class="underline"
                      :to="{
                        name: 'pallets-branch-transactions',
                        params: { id: branch.id },
                      }"
                    >
                      <u> {{ branch.name }}</u>
                    </router-link>
                  </td>
                  <td class="font-weight-bold">{{ branch.pallet_balance }}</td>
                  <td class="text-center text-warning">
                    {{
                      todaysSummary.filter((x) => x.id == branch.id)[0].received
                    }}
                  </td>
                  <td class="text-center text-info">
                    {{
                      todaysSummary.filter((x) => x.id == branch.id)[0].returned
                    }}
                  </td>
                  <td class="text-center text-warning">
                    {{
                      monthlySummary.filter((x) => x.id == branch.id)[0]
                        .received
                    }}
                  </td>
                  <td class="text-center text-info">
                    {{
                      monthlySummary.filter((x) => x.id == branch.id)[0]
                        .returned
                    }}
                  </td>
                  <td class="text-center text-warning">
                    {{
                      threeSummary.filter((x) => x.id == branch.id)[0].received
                    }}
                  </td>
                  <td class="text-center text-info">
                    {{
                      threeSummary.filter((x) => x.id == branch.id)[0].returned
                    }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td>TOTAL</td>
                  <td>
                    {{ branches.reduce((a, c) => a + c.pallet_balance, 0) }}
                  </td>
                  <td class="text-center">
                    {{ todaysSummary.reduce((a, c) => a + c.received, 0) }}
                  </td>
                  <td class="text-center">
                    {{ todaysSummary.reduce((a, c) => a + c.returned, 0) }}
                  </td>
                  <td class="text-center">
                    {{ monthlySummary.reduce((a, c) => a + c.received, 0) }}
                  </td>
                  <td class="text-center">
                    {{ monthlySummary.reduce((a, c) => a + c.returned, 0) }}
                  </td>
                  <td class="text-center">
                    {{ threeSummary.reduce((a, c) => a + c.received, 0) }}
                  </td>
                  <td class="text-center">
                    {{ threeSummary.reduce((a, c) => a + c.returned, 0) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="col-lg-4 my-auto">
            <radar-chart
              v-if="chartReady"
              :chart-data="chartData"
              :options="chartOptions"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-5" v-if="userHasPerms(['Pallet Administrator'])">
      <div class="card-body">
        <h5 class="card-title border-0 m-0">Suppliers Overview</h5>
        <small class="text-black-50"> Click supplier name for statement</small>
        <div class="row">
          <div class="col-lg-8">
            <table class="table mt-3">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td rowspan="2">Supplier</td>
                  <td rowspan="2">Balance</td>
                  <td colspan="2" class="text-center">Today</td>
                  <td colspan="2" class="text-center">
                    {{ moment().format("MMMM") }}
                  </td>
                  <td colspan="2" class="text-center">90 Days</td>
                </tr>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td class="text-center text-warning">In</td>
                  <td class="text-center text-info">Out</td>
                  <td class="text-center text-warning">In</td>
                  <td class="text-center text-info">Out</td>
                  <td class="text-center text-warning">In</td>
                  <td class="text-center text-info">Out</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="supplier in suppliers" :key="supplier.id">
                  <td>
                    <router-link
                      v-b-tooltip.hover
                      title="Supplier Statement"
                      :to="{
                        name: 'pallets-supplier-transactions',
                        params: { id: supplier.id },
                      }"
                    >
                      <u> {{ supplier.name }} </u>
                    </router-link>
                  </td>
                  <td class="font-weight-bold">
                    {{ supplier.pallet_balance }}
                  </td>
                  <td class="text-center text-warning">
                    {{
                      todaysSummarySupplierRecon.filter(
                        (x) => x.id == supplier.id
                      )[0].received
                    }}
                  </td>
                  <td class="text-center text-info">
                    {{
                      todaysSummarySupplierRecon.filter(
                        (x) => x.id == supplier.id
                      )[0].returned
                    }}
                  </td>
                  <td class="text-center text-warning">
                    {{
                      monthlySummarySupplierRecon.filter(
                        (x) => x.id == supplier.id
                      )[0].received
                    }}
                  </td>
                  <td class="text-center text-info">
                    {{
                      monthlySummarySupplierRecon.filter(
                        (x) => x.id == supplier.id
                      )[0].returned
                    }}
                  </td>
                  <td class="text-center text-warning">
                    {{
                      threeSummarySupplierRecon.filter(
                        (x) => x.id == supplier.id
                      )[0].received
                    }}
                  </td>
                  <td class="text-center text-info">
                    {{
                      threeSummarySupplierRecon.filter(
                        (x) => x.id == supplier.id
                      )[0].returned
                    }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td>TOTAL</td>
                  <td>
                    {{ suppliers.reduce((a, c) => a + c.pallet_balance, 0) }}
                  </td>
                  <td class="text-center">
                    {{
                      todaysSummarySupplierRecon.reduce(
                        (a, c) => a + c.received,
                        0
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      todaysSummarySupplierRecon.reduce(
                        (a, c) => a + c.returned,
                        0
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      monthlySummarySupplierRecon.reduce(
                        (a, c) => a + c.received,
                        0
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      monthlySummarySupplierRecon.reduce(
                        (a, c) => a + c.returned,
                        0
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      threeSummarySupplierRecon.reduce(
                        (a, c) => a + c.received,
                        0
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      threeSummarySupplierRecon.reduce(
                        (a, c) => a + c.returned,
                        0
                      )
                    }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="col-lg-4 my-auto">
            <radar-chart
              v-if="chartReady2"
              :chart-data="chartData2"
              :options="chartOptions2"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row my-5">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title border-0 m-0">Latest Movements</h5>
            <small class="text-muted">Click number for print</small>
            <table class="table">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td>Date</td>
                  <td>Number</td>
                  <td>Type</td>
                  <td>Movement</td>
                  <td>Quantity</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="movement in latestMovements" :key="movement.id">
                  <td>
                    {{
                      moment(new Date(movement.created_at)).format(
                        "DD MMM, HH:mm"
                      )
                    }}
                  </td>
                  <td>
                    <span
                      v-if="!isPrinting"
                      @click="
                        movementPrint(
                          movement.id,
                          movement.pallet_movement_number
                        )
                      "
                      class="text-primary font-weight-bold pointer"
                    >
                      {{ movement.pallet_movement_number }}
                    </span>

                    <span v-if="isPrinting">...</span>
                  </td>
                  <td>{{ movement.type }}</td>

                  <td>
                    <span
                      class="badge badge-primary"
                      v-if="movement.from_supplier"
                      >{{ movement.from_supplier.name }}</span
                    >
                    <span
                      class="badge badge-info"
                      v-if="movement.from_branch"
                      >{{ movement.from_branch.code }}</span
                    >

                    <i class="lni lni-arrow-right mx-1"></i>

                    <span
                      class="badge badge-primary"
                      v-if="movement.to_supplier"
                      >{{ movement.to_supplier.name }}</span
                    >
                    <span
                      class="badge badge-warning"
                      v-if="movement.to_branch"
                      >{{ movement.to_branch.code }}</span
                    >
                  </td>

                  <td>
                    {{ movement.debit }}
                    <span v-if="movement.type == 'Inter branch transfer'">
                      <i class="lni lni-arrow-right mx-1"></i
                    ></span>
                    {{ movement.credit }}
                    <span v-if="movement.has_discrepancy == 1">
                      <i class="lni lni-warning text-danger"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12 mt-5">
        <div class="card mt-5 mt-md-0">
          <div class="card-body">
            <h5 class="card-title border-0 m-0">Latest Adjustments</h5>
            <small class="text-muted">Click number for print</small>
            <table class="table">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td>Date</td>
                  <td>Number</td>
                  <td>Branch</td>
                  <td>Remark</td>
                  <td class="text-right">Qty</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="adjustment in latestAdjustments"
                  :key="adjustment.id"
                >
                  <td>
                    {{
                      moment(new Date(adjustment.created_at)).format(
                        "DD MMM, HH:mm"
                      )
                    }}
                  </td>
                  <td>
                    <span
                      v-if="!isPrinting"
                      @click="
                        adjustmentPrint(
                          adjustment.id,
                          adjustment.pallet_adjustment_number
                        )
                      "
                      class="text-primary font-weight-bold pointer"
                    >
                      {{ adjustment.pallet_adjustment_number }}
                    </span>

                    <span v-if="isPrinting">...</span>
                  </td>
                  <td>
                    <span class="badge badge-primary">{{
                      adjustment.branch.code
                    }}</span>
                    {{ adjustment.branch.name }}
                  </td>
                  <td>{{ adjustment.remark }}</td>
                  <td
                    class="text-right font-weight-bold"
                    :class="{ 'text-danger': adjustment.debit != null }"
                  >
                    <span v-if="adjustment.debit != null">-</span
                    >{{ adjustment.debit }} {{ adjustment.credit }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import palletRepo from "@/api/repos/palletRepo";
import RadarChart from "../../../components/charts/radar.vue";

export default {
  components: {
    RadarChart,
  },
  data() {
    return {
      branches: [],
      suppliers: [],
      pallets: [],
      latestAdjustments: [],
      latestMovements: [],
      openTransfers: [],
      todaysSummary: [],
      todaysSummarySupplierRecon: [],
      monthlySummary: [],
      monthlySummarySupplierRecon: [],
      threeSummary: [],
      threeSummarySupplierRecon: [],
      company_id: localStorage.getItem("current_company_id"),
      loading: false,
      isPrinting: false,
      chartReady: false,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
      chartReady2: false,
      chartData2: {
        labels: [],
        datasets: [],
      },
      chartOptions2: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      try {
        let { data } = await palletRepo.dashboard();
        this.pallets = data.pallets;
        this.latestAdjustments = data.latest_adjustments;
        this.latestMovements = data.latest_movements;
        this.openTransfers = data.open_transfers;
        this.todaysSummary = data.todays_summary;
        this.todaysSummarySupplierRecon = data.todays_summary_supplier_recon;
        this.monthlySummary = data.monthly_summary;
        this.monthlySummarySupplierRecon = data.monthly_summary_supplier_recon;
        this.threeSummary = data.three_summary;
        this.threeSummarySupplierRecon = data.three_summary_supplier_recon;

        let res2 = await palletRepo.branches();
        this.branches = res2.data.branches;
        let res = await palletRepo.suppliers(true);
        this.suppliers = res.data.suppliers;

        let tempChartData = {
          labels: [],
          datasets: [
            {
              label: "Pallets",
              data: [],
              borderWidth: 1,
              backgroundColor: "rgb(163,142,56,0.5)",
              borderColor: "rgb(163,142,56,1)",
            },
          ],
        };

        this.branches.forEach((e) => {
          tempChartData.labels.push(e.code);
          tempChartData.datasets[0].data.push(e.pallet_balance);
        });

        this.chartData = tempChartData;
        this.chartReady = true;

        let tempChartData2 = {
          labels: [],
          datasets: [
            {
              label: "Pallets",
              data: [],
              borderWidth: 1,
              backgroundColor: "rgb(163,142,56,0.5)",
              borderColor: "rgb(163,142,56,1)",
            },
          ],
        };

        this.suppliers.forEach((e) => {
          tempChartData2.labels.push(e.name.substring(0, 10));
          tempChartData2.datasets[0].data.push(e.pallet_balance);
        });

        this.chartData2 = tempChartData2;
        this.chartReady2 = true;
      } catch (e) {
        console.log(e);
      }
    },

    async adjustmentPrint(id, number) {
      this.isPrinting = true;

      try {
        let response = await palletRepo.adjustmentPrint(id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_adjustment_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.isPrinting = false;
      }
    },
    async movementPrint(id, number) {
      this.isPrinting = true;

      try {
        let response = await palletRepo.movementPrint(id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_movement_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.isPrinting = false;
      }
    },
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },

    current_company_id() {
      return this.$store.state.user.current_company_id;
    },
  },
};
</script>
